@if (bodyItem) {
  <div class="body-item-container">
    @switch (bodyItem.type) {
      @case ('heading') {
        <h2 class="grid-ui-body-item-heading">
          {{ bodyItem.value | updateLink }}
        </h2>
      }
      @case ('subheading') {
        <h3 class="grid-ui-body-item-subheading h-sup" [class.consecutive]="isConsecutiveH3()">{{ bodyItem.value | updateLink }}</h3>
      }
      @case ('paragraph') {
        <grid-ui-body-item-paragraph
          [class]="'item-paragraph'"
          [value]="bodyItem.value"
          (writtenContentLinkActionEmit)="emitWrittenContentLinkAction($event)"
        >
        </grid-ui-body-item-paragraph>
      }
      @case ('video') {
        <grid-ui-body-item-video [value]="bodyItem.value"> </grid-ui-body-item-video>
      }
      @case ('image') {
        <grid-ui-body-item-image [value]="bodyItem.value" (loaded)="handleImageLoaded()" [attr.data-testid]="'img-' + tabName">
        </grid-ui-body-item-image>
      }
      @case ('focusbox') {
        <grid-ui-body-item-focusbox [value]="bodyItem.value" (writtenContentLinkAction)="emitWrittenContentLinkAction($event)">
        </grid-ui-body-item-focusbox>
      }
      @case ('table') {
        <grid-ui-body-item-table [value]="bodyItem.value"> </grid-ui-body-item-table>
      }
      @case ('enhancedtable') {
        <grid-ui-body-item-table [value]="bodyItem.value"> </grid-ui-body-item-table>
      }
      @case ('datawrapper') {
        <grid-ui-body-item-datawrapper [value]="bodyItem.value"> </grid-ui-body-item-datawrapper>
      }
    }
  </div>
}
